type Handler<TValue, TResult> = TResult | ((value: TValue) => TResult)

type Cases = {
	// String and all cases defined
	<TValue extends string, TResult>(
		value: TValue,
		values: {
			[TKey in TValue]: Handler<TValue, TResult>
		},
	): TResult

	// Optional string or missing cases
	<TValue extends string, TResult>(
		value: TValue | undefined,
		values: {
			[TKey in TValue]?: Handler<TValue, TResult>
		},
	): TResult | undefined

	// Tagged type
	<TValue extends { type: string }, TType extends TValue['type'], TResult>(
		value: TValue,
		values: {
			[TKey in TType]: Handler<Extract<TValue, { type: TKey }>, TResult>
		},
	): TValue['type'] extends TType ? TResult : TResult | undefined

	// Optional tagged type
	<TValue extends { type: string }, TType extends TValue['type'], TResult>(
		value: TValue | undefined,
		values: {
			[TKey in TType]: Handler<Extract<TValue, { type: TKey }>, TResult>
		},
	): TResult | undefined
}

export const cases: Cases = (value: string | { type: string } | undefined, values: Record<string, any>) => {
	if (value === undefined) return undefined
	const type = typeof value === 'string' ? value : value.type

	const result = values[type]

	if (typeof result === 'function') {
		return result(value)
	}
	return result
}
